import * as React from 'react';
import { Button, Sidebar } from '@verclam/ui-kit';
import ConditionalLoader from '@Guidelines/Component/Loader/ConditionalLoader';

type Props = {
	readonly panelId: string;
	readonly visible: boolean;
	/** Number of active criteria; `0` disables reset. */
	readonly activeCount: number;
	readonly onHide: () => void;
	readonly onReset: () => void;
	readonly children: React.ReactNode;
};

/**
 * Side panel holding the filter fields on compact viewports. `children` are mounted only while the panel
 * is visible, so a field is never mounted twice. No wrapper is added: the page lays out its own fields.
 */
const FilterPanelSidebar: React.FC<Props> = ({
	panelId,
	visible,
	activeCount,
	onHide,
	onReset,
	children,
}) => {
	const footer = React.useMemo(
		() => (
			<React.Fragment>
				<Button label="Réinitialiser" text disabled={activeCount === 0} onClick={onReset} />
				<Button label="Voir les résultats" onClick={onHide} />
			</React.Fragment>
		),
		[activeCount, onReset, onHide],
	);

	return (
		<Sidebar
			id={panelId}
			visible={visible}
			onHide={onHide}
			position="right"
			header="Filtres"
			blockScroll
			ariaCloseLabel="Fermer les filtres"
			footer={footer}
		>
			<ConditionalLoader data={visible}>{children}</ConditionalLoader>
		</Sidebar>
	);
};

export default FilterPanelSidebar;
